import { PayerError } from '@payer-admin-ui/components/src/utils/errors';
import { SerializedError } from '@reduxjs/toolkit';

export const toPayerError = (error: SerializedError) =>
  new PayerError({ name: error.name, code: error.code, message: error.message, detail: error.stack });
